import { DIMENSIONS } from "@/data/constants";
import { Wind, Heart, Brain, Sparkles } from "lucide-react";

const icons = {
  corps: Wind,
  coeur: Heart,
  cerveau: Brain,
  conscience: Sparkles,
};

export const DimensionCard = ({ dim, testid }) => {
  const Icon = icons[dim.key];
  return (
    <div
      data-testid={testid}
      className="group rounded-2xl bg-white border border-[#E8DCC4] p-6 md:p-8 transition-transform duration-300 hover:-translate-y-1"
      style={{ borderTopColor: dim.color, borderTopWidth: 4 }}
    >
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
        style={{ backgroundColor: `${dim.color}1A`, color: dim.color }}
      >
        <Icon size={22} />
      </div>
      <h3 className="font-serif text-2xl text-[#1F2A24]" style={{ color: dim.color }}>
        {dim.label}
      </h3>
      <p className="font-sans text-xs tracking-[0.18em] uppercase mt-1 text-[#1F2A24]/50">
        {dim.tagline}
      </p>
      <ul className="mt-4 space-y-1.5">
        {dim.points.map((p) => (
          <li key={p} className="font-sans text-sm text-[#1F2A24]/80 flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ backgroundColor: dim.color }} />
            {p}
          </li>
        ))}
      </ul>
      <p className="mt-4 font-serif italic text-[15px] text-[#1F2A24]/70 leading-relaxed">
        {dim.idea}
      </p>
    </div>
  );
};

export const dimensionCards = DIMENSIONS;
